<template>
    <div class="catalogue">
        <div class="header-tool">
            <div class="header-tool-info">
                <Breadcrumb>
                    <BreadcrumbItem>首页</BreadcrumbItem>
                    <BreadcrumbItem>会刊广告征订表</BreadcrumbItem>
                </Breadcrumb>
                <div class="header-tool-title">会刊广告征订表</div>
            </div>
            <div class="header-tool-box">
                <div class="htb-item" @click="goOne">
                    <span>返回首页</span>
                </div>
            </div>
        </div>
        <div class="marginCss20">
            <p class="fontWig">截止日期：{{ endDate }}</p>
            <p class="fontWig marginTop20">《广州国际分析测试及实验室设备展览会暨技术研讨会会刊》是大会组委会唯一指定的参展商、参观商会议资料。这无疑是您宣传企业形象，推广自身产品，加强沟通联系的最佳舞台。
            </p>
            <div class="paddingCss20 backBlue marginTop20">
                <p v-html="instructions"></p>
            </div>
        </div>

        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" size="small" label-width="100px" class="demo-ruleForm"
            style="width:79%;margin-left:40px">

            <div style="display: flex;">
                <el-form-item label="单位名称" prop="exhibitorName">
                    <el-input disabled v-model="ruleForm.exhibitorName" class="input" placeholder="请输入单位名称"
                        style="width:500px;"></el-input>
                </el-form-item>
                <el-form-item label="展位号" prop="boothJson" style="margin-left: 100px;">
                    <el-input disabled v-model="ruleForm.boothJson" placeholder="请输入展位号" class="input" style="width:500px;"></el-input>
                </el-form-item>
            </div>
            <div style="display: flex;">
                <el-form-item label="联系地址" prop="address">
                    <el-input v-model="ruleForm.address" placeholder="请输入联系地址" class="input" style="width:500px;"></el-input>
                </el-form-item>
                <el-form-item label="邮编" prop="postcode" style="margin-left: 100px;">
                    <el-input v-model="ruleForm.postcode" placeholder="请输入邮编" class="input" style="width:500px;"></el-input>
                </el-form-item>
            </div>
            <div style="display: flex;justify-content: space-between;width: 1300px;" class="box">
                <div style="display: flex;">
                    <el-form-item label="联系电话" prop="tel">
                        <el-input  style="width: 200px;" v-model="ruleForm.tel" class="input2" placeholder="请输入联系电话"></el-input>
                    </el-form-item>
                    <el-form-item label="传真" prop="fax">
                        <el-input style="width: 200px;" v-model="ruleForm.fax" class="input2"  placeholder="请输入传真"></el-input>
                    </el-form-item>
                </div>
                <el-form-item label="联系人" prop="contractName" style="margin-left: 0px;">
                    <el-input class="input" v-model="ruleForm.contractName" placeholder="请输入联系人" style="width:500px;"></el-input>
                </el-form-item>

            </div>
            <div style="display: flex;">
                <el-form-item label="汇入单位" prop="name">
                    <p style="width:500px;">北京东方情缘广告有限公司</p>
                </el-form-item>
                <el-form-item label="汇入银行" prop="name" class="marn" style="margin-left: 100px;">
                    <p style="width:500px;">交通银行北京育惠东路支行</p>
                </el-form-item>
            </div>
            <div style="display: flex;">
                <el-form-item label="汇入帐号" prop="name">
                    <p style="width:500px;">110060971018010010447</p>
                </el-form-item>
            </div>
        </el-form>
        <div style="padding: 20px">
            <el-table :data="list" style="width: 100%" row-key="id" :stripe="true"
                :tree-props="{ children: 'childrens', hasChildren: 'hasChildren' }"
                :header-cell-style="{ background: '#fafafa', color: '#333' }">
                <el-table-column prop="name" label="项目" width="400" align="center" />
                <el-table-column prop="nullable" label="预定" align="center">
                    <template slot-scope="scope">
                        <el-checkbox v-model="scope.row.nullable"></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column prop="back" label="备注" align="center">
                    <template slot-scope="scope">
                        <el-input v-model.number='scope.row.back' type='text' size="small"
                            :disabled="scope.row.nullable ? false : true" maxlength='200' placeholder="请输入内容" />
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div style="margin-left:60px;display:flex;width:90%">
            <p style="width:90px">特殊要求：</p>
            <el-input type="textarea" v-model="ruleForm.otherRemark" maxlength="200" placeholder="请输入内容" :rows="4"
                show-word-limit></el-input>
        </div>





        <div class="marginCss20">
            <div class="paddingCss20 backBlue marginTop20">
                <span v-html="contactIllustrate"></span>
            </div>
        </div>
        <div class="flexCenter div_btu">
            <el-button type="primary" @click="submitForm('ruleForm')">保存并提交</el-button>
            <el-button @click="goOne">取消</el-button>
        </div>


        <!-- 选择文件上传方式 -->
        <!-- <imgUpload @upload:local="uploadLocal" @upload:material="uploadMaterial" :maxCount="1" v-model="uploadChooseShowed" /> -->
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
    name: "exhibition-info-catalogue",
    data () {

        return {
            catalogueInfoIsHave: false, // 会刊信息是否存在
            list: [
                { nullable: false, name: '封面', remark: '' },
                { nullable: false, name: '封底', remark: '' },
                { nullable: false, name: '封二', remark: '' },
                { nullable: false, name: '封三', remark: '' },
                { nullable: false, name: '扉页（目录前）', remark: '' },
                { nullable: false, name: '彩色整版', remark: '' },
                { nullable: false, name: '黑白整版', remark: '' },

            ],

            ruleForm: {
                exhibitorName: '',
                boothJson: '',
                address: '',
                postcode: '',
                tel: '',
                fax: '',
                contractName: '',
                otherRemark: '',

            },
            rules: {
                address: [
                    { required: true, message: '请输入联系地址', trigger: 'blur' },
                ],
                postcode: [
                    { required: true, message: '请输入邮编', trigger: 'blur' }
                ],
                tel: [
                    { required: true, message: '请输入联系电话', trigger: 'blur' }
                ],
                fax: [
                    { required: true, message: '请输入传真', trigger: 'blur' }
                ],
                contractName: [
                    { required: true, message: '请输入联系人', trigger: 'blur' }
                ],

            },
            loading: false,
            endDate: null,
            instructions: null,
            contactIllustrate: null,
            IsSubmitDeadlineToo: false
        };
    },
    components: {
        // imgUpload,
    },
    computed: {
        ...mapGetters({
            exhibitor: "loginModule/getExhibitor",
        }),

    },
    created () {
        this.init();


    },
    mounted () {
        this.ruleForm.exhibitorName = this.exhibitor.exhibitorName
        if (this.exhibitor.boothJson && this.exhibitor.boothJson.indexOf('[') != -1) {
            JSON.parse(this.exhibitor.boothJson).forEach((item, index) => {
                if (item.Code && !index == 0 && item.Code != 'null') { this.ruleForm.boothJson += `,${item.Code}` } else { this.ruleForm.boothJson += item.Code }
            });

        }

    },
    methods: {
        ...mapActions({
            setManageSettingQ: 'hostSetModule/setManageSettingQ', //获取
            updateJournaladvertrecord: 'exhibitionModule/updateJournaladvertrecord', //修改
            journaladvertrecordList: 'exhibitionModule/journaladvertrecordList', //列表
        }),
        goOne () {
            this.$router.push(`/exhibition/index/home`);

        },
        async submitForm (name) {
            let bool = this.regular.contrastDate(this.regular.compareDate(), this.endDate)
            // 为true 截止日期到了 不能提交
            if (bool) {
                console.log(bool);
                console.log(this.IsSubmitDeadlineToo, typeof (this.IsSubmitDeadlineToo));
                if (this.IsSubmitDeadlineToo == 'false') {
                    this.$message.warning("超过截止日期不能提交");
                    return
                }
            }

            let valid = await this.validForm(name);
            if (!valid) return
            console.log(this.exhibitor.id);
            const opt = {
                id: this.exhibitor.id,
                body: {
                    address: this.ruleForm.address,
                    postcode: this.ruleForm.postcode,
                    tel: this.ruleForm.tel,
                    fax: this.ruleForm.fax,
                    contractName: this.ruleForm.contractName,
                    otherRemark: this.ruleForm.otherRemark,
                    preBookJson: JSON.stringify(this.list),
                }
            }
            let res = await this.updateJournaladvertrecord(opt)
            if (res) {
                this.$Message.success("操作成功");
                this.init();
            } else {
                this.$Message.error("操作失败");
            }

        },


        async init () {
            let opt = {
                providerName: "Global",
                names: ['JournalAdvert.SubmitDeadline', 'JournalAdvert.FormDescription', 'JournalAdvert.ContractDescription', 'JournalAdvert.IsSubmitDeadlineToo']
            }
            let res = await this.setManageSettingQ(opt)
            if (res) {
                console.log(res, 'res');
                if (res[0].value) {
                    this.endDate = res[0].value
                }
                if (res[1].value) {
                    this.instructions = res[1].value
                }
                if (res[2].value) {
                    this.contactIllustrate = res[2].value
                }
                this.IsSubmitDeadlineToo = res[3].value
            }
            let res1 = await this.journaladvertrecordList(this.exhibitor.id)
            if (res1) {
                console.log(res1);
                this.ruleForm.address = res1.address
                this.ruleForm.postcode = res1.postcode
                this.ruleForm.tel = res1.tel
                this.ruleForm.fax = res1.fax
                this.ruleForm.contractName = res1.contractName
                this.ruleForm.otherRemark = res1.otherRemark
                if (res1.preBookJson) {
                    this.list = JSON.parse(res1.preBookJson)
                }
            }

        },


        validForm (name) {
            // 验证表单
            return new Promise((resolve, reject) => {
                this.$refs[name].validate((valid) => {
                    resolve(valid);
                });
            });
        },



    },
};
</script>

<style lang="scss">
.intTextarea {
    .ivu-form-item-error-tip {
        top: 75%;
    }
}

.no-label {
    .ivu-form-item-label:before {
        opacity: 0 !important;
    }
}
</style>
<style scoped lang="scss">

.catalogue{
    @media screen and (max-width: 1500px) {
        .input {
            width: 300px !important;
        }
        .box{
            width: 900px !important;
        }
        .input2 {
            width: 100px !important;
        }
        .marn{
            margin-left: 0 !important;
        }
    }
    @media screen and (max-width: 1160px) {
        .input {
            width: 200px !important;
        }
        .box{
            width: 700px !important;
        }
        .input2 {
            width: 100px !important;
        }
        .marn{
            margin-left: -100px !important;
        }
    }

}
</style>
